"use client";

import React from "react";

const FAQSchemaSnippet = () => {
  const faqData = {
    "@context": "http://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is Posh & Cake?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Posh & Cake is a Bespoke Bakery offering a variety of freshly made cake and baked goods, all prepared with the finest ingredients.",
        },
      },
      {
        "@type": "Question",
        name: "How can I place an order?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "You can place an order through our website, by calling or writing us at 0794 777 8028.",
        },
      },
      {
        "@type": "Question",
        name: "Where is Posh & Cake located?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We are located in Bristol.",
        },
      },
      {
        "@type": "Question",
        name: "Do you offer delivery?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, we offer delivery within the local area. Delivery charges may apply depending on the location.",
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqData)}</script>
    </>
  );
};

export default FAQSchemaSnippet;
